module.exports = __webpack_public_path__ + "img/step37_b_printer_power_desiccant_bags - Copy.c27d47a6.png";